// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import EmployeeStatusTable from "../../DataTables/MasterData/EmployeeStatus/EmployeeStatusTable";

const EmpStatusContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Employee Status" parent="Master Data" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Master Data Management</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage employee status options used throughout the HRIS for
                  employee and applicant personal information.
                </P>
                <EmployeeStatusTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EmpStatusContainer;
